import { jsx as _jsx } from "react/jsx-runtime";
import useIntersectionObserver from '../hooks/useIntersectionObserver';
export const IntersectionLine = ({ onScrollEnd }) => {
    const intersectionRef = useIntersectionObserver(onScrollEnd ?? (() => { }), {
        threshold: 0,
        rootMargin: '100px',
    });
    return _jsx("div", { ref: intersectionRef });
};
